<template>
  <div>
    <!-- type="0" :route="route"  -->
    <Header v-if="schoolCode === '10294'" title="审核" :casLogin="casLogin" type="0" :route="route_tk.route"></Header>
    <Header v-else title="审核" :casLogin="casLogin" ></Header>
    <div class="stop-item">
      <div style="width:100%;">
        <van-cell-group>
          <van-field
            v-if="schoolCode == '10013'"
            v-model="shyj"
            label="上一级审核意见"
            type="textarea"
            input-align="right"
            autosize
            readonly
          />
          <van-field
            v-if="isShowFile || shyjData.fileurl"
            v-model="fj"
            type="textarea"
            autosize
            input-align="right"
            label="附件"
            readonly
          />
          <van-field
            v-model="spjg"
            label="审批结果"
            placeholder="请点击选择"
            readonly
            is-link
            @click="showPicker1 = true"
            input-align="right"
          />
          <van-field
            v-model="person"
            v-if="shr_flag == '1' && spjgId == '1'"
            label="下一步审核人"
            placeholder="请点击选择"
            readonly
            is-link
            @click="peoplePop = true"
            input-align="right"
          />
          <van-field
            v-model="bkcjkztext"
            v-if="schoolCode === '10294' && ywcode == '019'"
            label="补考成绩最高限70分"
            placeholder="请点击选择"
            readonly
            is-link
            @click="showPicker3 = true"
            input-align="right"
          />
          <!--          <van-field-->
          <!--            name="uploader"-->
          <!--            input-align="right"-->
          <!--            class="upload-line"-->
          <!--            label="附件"-->
          <!--            v-if="!route_tk.new"-->
          <!--          >-->
          <!--            <template #input>-->
          <!--              <div id="myMain" @click="reImage"></div>-->
          <!--            </template>-->
          <!--          </van-field>-->
          <van-field
            class="xx"
            v-model="remark"
            :label="schoolCode == '10013'?'审核意见':'备注'"
            placeholder="非必填"
            input-align="right"
          />
          <van-field
            style="display:none"
            label="备注"
            placeholder="非必填"
            input-align="right"
          />
        </van-cell-group>
      </div>
      <div v-if="isShowFile || shyjData.fileurl">
        <van-button class="bottom-button" type="default" @click="CheckFile"
          >查看附件</van-button
        >
        <van-button class="bottom-button1" type="default" @click="pushExamine"
          >审核</van-button
        >
      </div>
      <div v-else>
        <van-button class="bottom-button2" type="default" @click="pushExamine"
          >审核</van-button
        >
      </div>
      <van-popup v-model="showPicker1" position="bottom">
        <van-picker
          show-toolbar
          :columns="isEndShow == '1' ? columns : columns1"
          @confirm="onConfirm1"
          :item-height="35"
          @cancel="showPicker1 = false"
        />
      </van-popup>
      <van-popup v-model="showPicker3" position="bottom">
        <van-picker
          show-toolbar
          :columns="bkcjkzColumns"
          @confirm="onConfirm3"
          :item-height="35"
          @cancel="showPicker3 = false"
        />
      </van-popup>
      <van-popup v-model="peoplePop" position="bottom">
        <div class="apply-pop">
          <div class="pop-title">
            <i class="closeIcon" @click="peoplePop = false"></i>
            <p>审核人</p>
            <i class="conIcon" @click="resetCancel()"></i>
          </div>
          <div class="person">
            <button
              class="per-btn"
              ref="person"
              @click="personTap($event, index)"
              v-for="(item, index) in personList"
              :key="item.id"
            >
              {{ item.name }}
            </button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="show" id="reImg"></van-popup>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import tApi from "../../../../utils/teacher";
import Vue from "vue";
import { Popup, Toast } from "vant";

Vue.use(Popup);
export default {
  data() {
    return {
      casLogin: sessionStorage.getItem("casLogin"),
      route: this.$route.params.route,
      remark: "审核通过",
      shyj: "",
      fj: "",
      spjg: "通过",
      spjgId: "1",
      shr: "",
      shrId: "",
      columns: [
        { text: "通过", value: "1" },
        { text: "不通过", value: "0" },
        { text: "终止流程", value: "2" }
      ],
      bkcjkzColumns:[
        { text: "是", value: "1" },
        { text: "否", value: "0" }
      ],
      columns1: [{ text: "通过", value: "1" }, { text: "不通过", value: "0" }],
      showPicker1: false,
      showPicker3: false,
      peoplePop: false,
      bkcjkztext:'',
      bkcjkzvalue:'',
      shr_list: [],
      uploader: [],
      route_params: {},
      personList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      isShowFile: false,
      person: "",
      personId: "",
      route_tk: {},
      shr_flag: false,
      reset: "",
      resetId: "",
      ywinstanceid: "",
      isEndShow: "",
      image: "",
      show: false,
      img: {},
      img1: {},
      shyjData: {},
      schoolCode: sessionStorage.getItem("schoolCode"),
      ywcode:''
    };
  },
  watch: {
    spjgId: {
      handler(n) {
        if (n == "1") {
          this.remark = "审核通过";
        }
        if (n == "0") {
          if(this.schoolCode == '10054'){
            this.remark = "";
          }else{
            this.remark = "审核不通过";
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    this.route_tk = JSON.parse(decodeURI(this.$route.params.route_params));
    console.log(this.route_tk);
    // if (!this.route_tk.new) {
    this.getList();
    // }
  },
  methods: {
    onOversize(file) {
      this.$toast.fail("文件大小不能超过2M");
    },
    CheckFile() {
      localStorage.setItem("shyjData", JSON.stringify(this.shyjData));
      let type = this.fj.substring(
        this.fj.lastIndexOf(".") + 1,
        this.fj.length
      );
      if (
        type.indexOf("xsl") !== -1 ||
        type.indexOf("xslx") !== -1 ||
        type.indexOf("xls") !== -1
      ) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (type.indexOf("docx") !== -1) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (type.indexOf("pdf") !== -1) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (
        type.indexOf("jpg") !== -1 ||
        type.indexOf("png") !== -1 ||
        type.indexOf("jpeg") !== -1
      ) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else {
        Toast("抱歉!当前文件不支持预览");
      }
    },
    resetCancel() {
      this.peoplePop = false;
      this.person = this.reset;
      this.personId = this.resetId;
    },
    reImage() {
      this.show = true;
      this.$nextTick(() => {
        if (this.img.width >= 320) {
          this.img.style.width = "320px";
        } else {
          this.img.style.width = "auto";
        }
        document.getElementById("reImg").appendChild(this.img);
      });
    },
    async getList() {
      const params = {
        id: this.route_tk.id_sh
      };
      console.log("id_sh:"+this.route_tk.id_sh)
      // let formData = new FormData();
      // formData.append('id', this.route_tk.id_sh);
      if (this.schoolCode == "10013" || this.schoolCode == "10537") {
        const sh = await tApi.querySybShyj(params);
        if (sh.data !== null) {
          this.shyj = sh.data.shyj ? sh.data.shyj : "无";
          this.fj = sh.data.qzwffilename ? sh.data.qzwffilename : "无";
          this.shyjData = sh.data;
        }
      }
      const res = await Api.getshXx(params);
      if (res.code == "0") {
        this.$toast.fail(res.Msg);
      }
      this.ywcode = res.ywcode;
      if(this.schoolCode === '10294' && this.ywcode == '019'){
        if(res.bkcjkz === '1'){
          this.bkcjkztext = '是'
          this.bkcjkzvalue = '1'
        }else{
          this.bkcjkztext = '否'
          this.bkcjkzvalue = '0'
        }
      }
      this.shr_flag = res.xsxyb;
      let concatList = [];
      if (res.nextRoleList && res.nextRoleList.length > 0) {
        res.nextRoleList.forEach((item, index) => {
          concatList[index] = {
            name: item.userrealname,
            id: item.userid,
            isBtn: 0
          };
        });
      }
      this.isEndShow = res.qzwfdefine.isend;
      this.ywinstanceid = res.qzwfexample.ywinstanceid;
      this.personList = this.personList.concat(concatList);
      if (res.recList.length == 0) {
        this.isShowFile = false;
      } else {
        this.isShowFile = true;
      }

      const ret = await Api.downfile({
        tkid: this.route_tk.ywinstanceid
      });
      if (ret.type == "application/json") {
        let span = document.createElement("span");
        span.innerText = "无";
        document.getElementById("myMain").appendChild(span);
        return;
      }
      let blob = new Blob([ret], {
        type: ["image/png", "image/jpeg", "image/gif"]
      });
      this.img = document.createElement("img");
      this.img1 = document.createElement("img");
      let url = window.URL.createObjectURL(blob);
      this.img.src = url;
      this.img.onload = function() {
        window.URL.revokeObjectURL(url);
      };
      this.img1.src = url;
      this.img1.onload = function() {
        window.URL.revokeObjectURL(url);
      };
      this.img1.style.width = "80px";
      this.img1.style.height = "80px";
      document.getElementById("myMain").appendChild(this.img1);
    },
    async afterRead(file) {
      let formData = new FormData();
      formData.append("ywinstanceid", this.route_tk.xq_id || this.ywinstanceid);
      formData.append("id", this.route_tk.id_sh);
      formData.append("file", file.file);
      const res = await Api.fileUpload(formData);
      this.$toast(res.Msg);
    },
    async pushExamine() {
      if (this.shr_flag == "1" && this.spjgId == "1" && !this.person) {
        this.$toast("请选择下一步审核人");
        return;
      }
      if( this.schoolCode == '10054' && (this.remark  == null || this.remark == "") ){
        this.$toast("请输入备注");
        return;
      }
      const params = {
        id: this.route_tk.id_sh,
        type: this.spjgId,
        shyj: this.remark,
        code: this.route_tk.sh_flag
      };
      if (this.shr_flag == "1") {
        if(this.personId==''){
          let userids_temp = "";
          for(let i=0;i<this.personList.length;i++){
          if(this.personList[i].id!=""){
            if(i==this.personList.length-1){
              userids_temp +=this.personList[i].id;
            }else{
              userids_temp +=this.personList[i].id+",";
            }
          }
        }
          params.userids = userids_temp;
        }else{
          params.userids = this.personId;
        }

      }
      if(this.schoolCode === '10294' && this.ywcode == '019'){
        params.bkcjkz =this.bkcjkzvalue
      }
      let res = {};
      if (this.route_tk.new) {
        res = await Api.workflowAuditingNew(params);
      } else {
        res = await Api.workflowAuditing(params);
      }
      if (res.code == "1") {
        if(this.ywcode=='6238'){
          this.$toast("审核成功！");
          setTimeout(() => {
            this.$router.replace("/teacher/examine/bdkqshList");
        }, 2000);

          return;
        }
        this.$router.push({
          path: "/teacher/examine/examineCommomSuccess",
          query: { params: this.route_tk }
        });
      } else {
        this.$toast(res.Msg);
        if(this.ywcode=='6238'){
          return;
        }
        setTimeout(() => {
          if (!!this.route_tk.route) {
            this.$router.replace(this.route_tk.route);
          } else {
            this.$router.replace("/teacher/examineIndex");
          }
        }, 2000);
      }
    },
    onConfirm1(value) {
      this.spjg = value.text;
      this.spjgId = value.value;
      this.showPicker1 = false;
    },
    onConfirm2(value) {
      this.shr = value.text;
      this.shrId = value.value;
      this.showPicker2 = false;
    },
    onConfirm3(value) {
      this.bkcjkztext = value.text;
      this.bkcjkzvalue = value.value;
      this.showPicker3 = false;
    },
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.personList[res].isBtn == 0) {
        this.personList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.personList[res].isBtn == 1) {
        this.personList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.personList) {
        if (this.personList[res].name == "全部") {
          this.personList[i].isBtn = 0;
          this.personList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.personList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.personList[i].isBtn == 1) {
          strList = strList.concat(this.personList[i].name);
          idList = idList.concat(this.personList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    }
    // handleClick() {
    //   this.$router.push({ path: '/teacher/filePreview', query: {
    //       data: JSON.stringify(this.shyjData)
    //     }})
    // }
  }
};
</script>
<style scoped lang="less">
.stop-item {
  width: 100%;
  display: flex;
  justify-content: center;
}
.bottom-button,
.bottom-button1,
.bottom-button2 {
  font-size: 16px;
  font-weight: 600;
  height: 44px;
  line-height: 44px;
  position: absolute;
  bottom: 20px;
  border-radius: 3px;
}
.bottom-button {
  width: calc(~"50% - 30px");
  left: 20px;
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.bottom-button1 {
  width: calc(~"50% - 30px");
  right: 20px;
  background-color: @attendance-background-color-1;
  color: white;
}
.bottom-button2 {
  left: 20px;
  width: calc(~"100% - 40px");
  background-color: @attendance-background-color-1;
  color: white;
}
.center input::placeholder {
  color: @attendance-background-color-2;
  font-weight: 0 !important;
}
/deep/ .van-field__control {
  color: @attendance-color-1 !important;
  font-weight: 600;
}
/deep/ .van-cell {
  font-size: 16px;
}
/deep/.van-field__label {
  width: 120px;
}
/deep/ .van-picker__cancel {
  color: rgba(0, 0, 0, 0);
}
/deep/ .van-picker__confirm {
  color: rgba(0, 0, 0, 0);
}
.xx {
  /deep/ .van-field__body {
    padding-right: 6px;
  }
  /deep/ .van-field__label {
    width: 72px;
  }
}
.upload-line {
  /deep/ .van-field__label {
    width: 75px;
  }
}
/deep/ .van-cell {
  padding: 20px 16px 10px 20px;
}
/deep/ .van-cell:not(:last-child)::after {
  left: 20px;
  right: 20px;
}
/deep/ .van-cell__right-icon {
  margin-left: 3px;
  color: @attendance-background-color-2;
}
/deep/ .van-picker-column {
  position: relative;
}
/deep/ .van-picker-column::before {
  width: 140px !important;
  height: 1px !important;
  background-color: @attendance-background-color-2!important;
  content: "" !important;
  position: absolute !important;
  top: 70px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  border-bottom: none !important;
  border-top: none !important;
}
/deep/ .van-picker-column::after {
  width: 140px;
  height: 1px;
  background-color: @attendance-background-color-2;
  content: "";
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
}
/deep/
  .van-ellipsis
  /deep/
  .van-picker-column__item
  /deep/
  .van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}

.stop-item .closeIcon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.stop-item .conIcon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.stop-item .pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.stop-item .pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  border-radius: 5px 5px 0 0;
}
.stop-item .person {
  padding: 57px 15px 15px 15px;
}
.stop-item .person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}
.stop-item .apply-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.stop-item .person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
.stop-item
  /deep/.van-popup
  /deep/.van-popup--bottom
  /deep/.van-picker
  /deep/.van-picker-column {
  position: relative;
}
.stop-item
  /deep/.van-ellipsis
  /deep/.van-picker-column__item
  /deep/.van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}
#reImg {
  background-color: transparent;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Examine/commom/index.vue